import { TradeDirection, TradeSide } from './types';

export const getTradeDirectionFromTradeSide = (
  tradeSide?: string | null,
): TradeDirection | undefined => {
  const normalized = String(tradeSide || '')
    .trim()
    .toUpperCase()
    .replace(/[\s-]/g, '_');

  switch (normalized) {
    case TradeSide.AboveAsk:
    case 'ABOVEASK':
    case TradeDirection.AboveAsk:
      return TradeDirection.AboveAsk;
    case TradeSide.Ask:
    case TradeDirection.Ask:
      return TradeDirection.Ask;
    case TradeSide.Mid:
    case TradeDirection.Mid:
      return TradeDirection.Mid;
    case TradeSide.Bid:
    case TradeDirection.Bid:
      return TradeDirection.Bid;
    case TradeSide.BelowBid:
    case 'BELOWBID':
    case 'BBID':
    case TradeDirection.BelowBid:
      return TradeDirection.BelowBid;
    default:
      return undefined;
  }
};
